export const ACTION_ANIMAL = "Animal";
export const ACTION_ROLE = "Role";
export const ACTION_RESET = "Reset";
export const ACTION_ETAT = "Etat";
export const ACTION_ADD = "Add";
export const ACTION_LOT = "Lot";
export const ACTION_EDIT = "Edit";
export const ACTION_DETAIL = "Detail";
